module.exports = __webpack_public_path__ + "img/about-3-back.3fcce8e7.png";